<div class="auth-wrapper">
  <app-a-select [objectList]="languageList" [variable]="selectedLang" [value]="'value'"
    [label]="translateService.translate('Select Language')" (variableChange)="changeLang($event)"
    [type]="'Object'"></app-a-select>
  <div class="auth-header" *ngIf="!backEnd.getUser()">
    <h1>{{ 'Welcome To Vanshavali' | translate }}</h1>
  </div>
  <div class="auth-header" *ngIf="backEnd.getUser()">
    <h1>{{ 'Logged In' | translate }}</h1>
    <p>{{ 'Manage your active account below' | translate }}</p>
  </div>

  <ion-card class="auth-card">
    <ion-card-content>
      <div *ngIf="backEnd.getUser()" class="user-session">
        <div class="user-info-row">
          <ion-icon name="mail-outline" color="primary"></ion-icon>
          <span class="user-email">{{backEnd.getUser()?.email || backEnd.getUser()?.phone}}</span>
          <ion-button (click)="auth.signOut(true,true)" color="danger" fill="clear" size="small" class="logout-btn">
            {{ 'Logout' | translate }}
          </ion-button>
        </div>
      </div>
      <div *ngIf="!backEnd.getUser()" class="login-options">

        <app-phone-input [hidden]="currentStep !== 'phone'" (otpSent)="onOtpSent($event)"></app-phone-input>
        <app-otp-verification [hidden]="currentStep !== 'otp'" [phoneNumber]="phoneNumber" [name]="name"
          (verificationComplete)="onVerificationComplete($event)" (resendOTP)="onResendOTP()">
        </app-otp-verification>
        <div class="divider" *ngIf="currentStep === 'phone'">
          <span>{{ 'OR' | translate }}</span>
        </div>
        <ion-button *ngIf="currentStep === 'phone'" (click)="googleLogin()" expand="block" class="google-btn"
          shape="round">
          <img slot="start" src="assets/imgs/google.png" alt="Google">
          {{ 'Sign in with Google' | translate }}
        </ion-button>
        <ion-button *ngIf="currentStep === 'otp'" (click)="goBackToPhoneInput()" fill="clear" size="small"
          expand="block" color="medium" class="ion-margin-top">
          <ion-icon name="arrow-back-outline" slot="start"></ion-icon>
          {{ 'Change Phone Number' | translate }}
        </ion-button>
      </div>

    </ion-card-content>
  </ion-card>
</div>